import { TZDate } from '@date-fns/tz';
import { SpreadsheetExportFileType } from 'app/shared/enums/spreadsheet-export-file-type.enum';

export abstract class AbstractNotificationCardModel {
  public colorClass: string;
  public discriminator: string;
  public messageLine1: string | undefined;
  public notificationDate: TZDate | null;
  public readDate: TZDate | null;
  public spreadsheetExportFileType?: SpreadsheetExportFileType;
  public title: string;
  public uuid: string | null | undefined;
}
